import { StyleSheet, Text, View } from 'react-native';
import React, { FC, useMemo, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import dayjs from 'dayjs';
import { BookingType } from '../types';
import { Button } from '../../../components/Button';
import { COLORS, FONTS } from '../../../constants';
import { IBookedSport } from '../../../types/sports.types';
import { convertToAmPm } from '../../../services/utils';

interface BookingCollapseSportProps {
  bookingDetail: IBookedSport;
  onCancelBooking?: (bookingId: string) => void;
  isPast?: boolean;
}

const BookingCollapseSport: FC<BookingCollapseSportProps> = ({
  bookingDetail,
  onCancelBooking,
  isPast = false,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const renderHeaderCollapse = useMemo(() => {
    return (
      <TouchableOpacity
        style={[styles.header]}
        onPress={() => {
          setOpen(!open);
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            paddingVertical: 10,
            flex: 1,
            // justifyContent:'space-between'
          }}
        >
          <View
            style={{
              width: '35%',
              flexDirection: 'row',
              alignItems: 'center',
              paddingRight: 10,
            }}
          >
            <Image
              source={
                open == true
                  ? require('../../../assets/up-arrow.png')
                  : require('../../../assets/down-arrow.png')
              }
              style={{
                width: 15,
                height: 8,
                marginHorizontal: 10,
              }}
            />
            <View style={{ flexDirection: 'column', flexShrink: 1 }}>
              <Text style={styles.headerText} numberOfLines={3}>
                {bookingDetail.bk_bsdesc}
              </Text>
              <Text style={styles.typeText}>TYPE: SPORT</Text>
              <Text style={styles.typeText}>
                Court No: {bookingDetail.bk_emdesc}
              </Text>
            </View>
          </View>
          <View style={{ width: '20%' }}>
            <Text
              style={[
                styles.headerText,
                {
                  alignItems: 'flex-start',
                },
              ]}
            >
              {dayjs(bookingDetail.book_date).format('DD MMMM YYYY')}
            </Text>
          </View>
          <View style={{ width: '25%' }}>
            <Text
              style={[
                styles.headerText,
                {
                  alignItems: 'flex-start',
                },
              ]}
            >
              {convertToAmPm(bookingDetail.bk_time)} -{' '}
              {convertToAmPm(bookingDetail.bk_totime)}
            </Text>
          </View>
          <Text
            style={[
              styles.headerText,
              {
                width: '30%',
                textAlign: 'center',
              },
            ]}
          >
            {bookingDetail.bk_stat == 'B'
              ? 'Booked'
              : bookingDetail.bk_stat == 'X'
              ? 'Cancelled'
              : 'Complete'}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }, [bookingDetail, open]);

  const renderBodyCollapse = useMemo(() => {
    if (open) {
      return (
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <View style={{ marginLeft: 30 }}>
            {bookingDetail.image && (
              <Image
                source={{ uri: bookingDetail.image }}
                alt="Booking image"
                style={{
                  width: 120,
                  height: 90,
                  resizeMode: 'cover',
                }}
              />
            )}
          </View>
          <View style={{ width: '20%', minWidth: 100, alignItems: 'center' }}>
            {bookingDetail.bk_stat === 'B' && !isPast && (
              <Button
                style={STYLE_VARS.dangerButton}
                text="CANCEL"
                className=""
                onPress={() => {
                  if (onCancelBooking) onCancelBooking(bookingDetail.bk_id);
                }}
              />
            )}
          </View>
        </View>
      );
    }
    return undefined;
  }, [bookingDetail, open, onCancelBooking, isPast]);

  return (
    <View
      style={{
        paddingVertical: 10,
        paddingHorizontal: 10,
        borderWidth: 0.5,
        borderColor: STYLE_VARS.fccDarkGrey,
        marginBottom: 10,
      }}
    >
      {renderHeaderCollapse}
      {renderBodyCollapse}
    </View>
  );
};

export default BookingCollapseSport;

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 15,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: STYLE_VARS.textColor,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
  typeText: {
    fontSize: 13,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: COLORS.DARKER_GREY,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
});
